import React, { useEffect } from "react";
import { SubTaskFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Inputs, Buttons } from "components";
import moment from "moment";

const SubTaskForm = ({
  initialValues,
  permission,
  mainTaskCode,
  onSubmit,
  onCancel,
  onDelete,
}) => {
  const schema = yup.object().shape({
    sub_task_code: yup.string().required("Required"),
    promotion_type: yup.string().required("Required"),
    appointment_date: yup.string().required("Required"),
    appointment_time: yup.string().required("Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialValues) {
      reset({
        ...initialValues,
        appointment_time: new Date(
          moment(initialValues.appointment_time, "HH:mm")
        ),
      });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SubTaskFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="title_sub_wrap">
          <div className="title">Main Task</div>
          <div className="title_detail">{mainTaskCode}</div>
        </div>
        <div className="body_form_campaign">
          <div className="input_warp">
            <div className="left_box">Sub Task</div>
            <div className="right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextField
                    {...field}
                    errors={errors.sub_task_code?.message}
                    disabled={initialValues}
                  />
                )}
                name="sub_task_code"
                defaultValue=""
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Promotion/Discount </div>
            <div className="right_box">
              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.Radio
                      {...field}
                      theme_standard
                      disabled={initialValues}
                      options={[
                        {
                          label: "Main Promotion",
                          value: "1",
                        },
                        {
                          label: "E-Voucher Code",
                          value: "2",
                        },
                      ]}
                      errors={errors.promotion_type?.message}
                    />
                  )}
                  name="promotion_type"
                  defaultValue=""
                />
              </div>

              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      disabled={initialValues ? true : false}
                      type="text"
                      errors={errors.e_voucher_code_ref_code?.message}
                    />
                  )}
                  name="e_voucher_code_ref_code"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Appointment Date</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.DateTime
                    {...field}
                    placeholder={"Date"}
                    errors={errors.appointment_date?.message}
                    showYearDropdown
                  />
                )}
                name="appointment_date"
                // defaultValue={{ label: '1', value: '1' }}
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Appointment Time</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.DateTime
                    {...field}
                    showTimeSelect
                    showTimeSelectOnly
                    dateFormat="HH:mm"
                    placeholder={"Time"}
                    errors={errors.appointment_time?.message}
                    showYearDropdown
                  />
                )}
                name="appointment_time"
                // defaultValue={{ label: '1', value: '1' }}
              />
            </div>
          </div>
          <div className="btn_zone">
            <div className="w120">
              <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
            </div>

            <div className="w120">
              <Buttons.BgStandard
                type="submit"
                label="Save"
                // disabled={initialValues && initialValues.is_center}
              />
            </div>
          </div>
        </div>
      </form>
    </SubTaskFormStyled>
  );
};

SubTaskForm.propTypes = {};

export default SubTaskForm;
